const colors = {
	primary: '#a61d22',
	secondary: '#1976d2',
	black: '#000000',
	slate: '#3f3d56',
	lightGrey: '#f7f7f7',
	grey: '#f2f2f2',
	white: '#ffffff',
	tomato: '#E81224'
};

export default colors;
